import { MenuItem, ModifierDetail } from '@/core/models';
import { ModifierExtractorUtil } from '../utils';

export abstract class BaseModifierPriceCalculationStrategy {
	public calculationModifiersTotal(menuItem: MenuItem): bigint {
		const detailsWithQuantity = ModifierExtractorUtil.extractModifierDetails(menuItem, (detail: ModifierDetail) => !!detail?.addExtra);

		const totalExtras = detailsWithQuantity.reduce((acc: bigint, detail: ModifierDetail) => {
			const modifierPrice = detail?.isFree ? 0n : this.extractFactorPrice(detail);
			const extraQuantity = BigInt(detail?.cantidad ?? 0n);
			const extraPrice = extraQuantity > 0n ? this.extractFactorPrice(detail) * extraQuantity : 0n;

			return acc + modifierPrice + extraPrice;
		}, 0n);

		return totalExtras;
	}

	protected abstract extractFactorPrice(modifierDetail: ModifierDetail): bigint;
}
